import { CardContent, CardHeader, Stack } from "@mui/material"
import MaterialTypography from "../../../components/MaterialTypography"
import { Add, FileUpload, FilterAlt } from "@mui/icons-material"
import MaterialButton from "../../../components/MaterialButton"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import Table from "../../../components/Table"
import { deleteData, fetchData } from "../../../services"
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import { useDispatch, useSelector } from "react-redux"
import BulkUpload from "../../../components/blukUplod"
import { useLoading } from "../../../components/Loading"
import { useSnackbar } from "../../../context/popup"
import PincodeListFilterDialog from './components/PincodeListFilterDialog.js';

const PincodeList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { setCircleLoading } = useLoading();
    const { showSnackbar } = useSnackbar();

    const currentPage = useSelector((state) => state?.generalPincodeStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.generalPincodeStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.generalPincodeStore?.totalPages);

    const [pincodeData,setPincodeData] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
        cityId: "",
    });

    useEffect(() => {
        fetchPincodeList();
    },[isRefresh, currentPage, rowsPerPage, search])
    
    //API List
    const fetchPincodeList = async () => {
        setCircleLoading(true);
        try {
        let url = `/reference/general/pincode?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}&cityId=${filterData?.cityId}`
        if(filterData.isActive !== "" && filterData.isActive !== null && filterData.isActive !== undefined) {
            url += `&isActive=${filterData.isActive}`;
        }
        const response = await fetchData(url);
        
        if(response?.success){
            setPincodeData(response?.data?.items);
            dispatch(setTotalPages(response?.data?.totalPages));
        }
        else{
            //throw error
            showSnackbar("Failed to fetch data", "error");
        }
        } catch (error) {
        console.error('Error Fetching States:', error);
        showSnackbar(error?.response?.data?.message || 'Network Error', "error");
        }
        finally{
            setCircleLoading(false);
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try {
            const response = await deleteData(`/reference/general/pincode-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);
            if(response?.success){
                showSnackbar(response?.message, "success");
            }
            else{
                showSnackbar(response?.message, "error");
            }
        } catch (error) {
            console.error("Error deleting data:", error);
            showSnackbar("Failed to delete Motor Make", "error");
        }
    };
    
    //Table Mapping
    const pincodeListTable = {
        columns: [
            {
            key: "sno",
            label: "S.No.",
            renderCell: (row) => row.sno,
            },
            {
            key: "code",
            label: "Pin Code",
            renderCell: (row) => row.code,
            },
            {
            key: "city",
            label: "City",
            renderCell: (row) => row.city,
            },
            {
            key: "district",
            label: "District",
            renderCell: (row) => row.district,
            },
            {
            key: "state",
            label: "State",
            renderCell: (row) => row.state,
            },
            {
            key: "country",
            label: "Country",
            renderCell: (row) => row.country,
            },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            },
        ],

        rows: pincodeData?.map((pincode, index) => ({
            id: pincode?.id,
            sno: index + 1,
            code: pincode?.pincode || "",
            city: pincode?.city?.name || "",
            district: pincode?.city?.district?.name || "",
            state: pincode?.city?.district?.state?.name || "",
            country: pincode?.city?.district?.state?.country?.name || "",
            isActive: pincode?.isActive,

        })),
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/general-master/pincode-list/pincode-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/general-master/pincode-list/pincode-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    //Handle Click Add Pincode
    const handleAddNewPincode = () => {
        navigate(`/general-master/pincode-list/pincode-details`)
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleSearch = (value) => {
        setSearch(value);
    };

  return (
    <DashboardLayout>
        <CardHeader
        title={(
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        PIN Code List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of PIN Codes around the world.
                    </MaterialTypography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FilterAlt/>}
                    onClick={(event) => setAnchorEl(event.currentTarget)}

                    >
                        Filter
                    </MaterialButton>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FileUpload/>}
                    onClick={() => setOpenUploadFileDialog(true)}>
                        Bulk Upload
                    </MaterialButton>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<Add />}
                    onClick={() => handleAddNewPincode()}
                    >
                        Pin code
                    </MaterialButton>
                </Stack>
            </Stack>
        )} 
        />
        <CardContent>
             <Table
                columns={pincodeListTable?.columns}
                data={pincodeListTable?.rows}
                actions={actions}
                pagination={{
                    totalPages,
                    currentPage,
                    onPageChange: (page) => handlePaginationChange(page),
                    rowsPerPage,
                    onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                    rowsPerPageOptions: [5, 10, 15, 20],
                }}
                getRowKey={(row) => row.id}
                className="custom-table"
                noDataLabel="No PIN Codes found"
                handleSearch={handleSearch}
                />
        </CardContent>
        <BulkUpload
            open={openUploadFileDialog}
            setOpen={setOpenUploadFileDialog}
            endPoint="/reference/master/bulkUpload/general-pincode"
            fetchList={fetchPincodeList}
        />
        <PincodeListFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchPincodeList();  // call API after filter applied
        }}
        />
    </DashboardLayout>
  )
}

export default PincodeList